import { setRemoteDefinitions } from '@nrwl/angular/mf';

fetch('/env-config.json')
    .then(response => response.json())
    .then(vars => init(vars.environment));

function init(environment: 'dev' | 'pre' | 'pro' ) {
  window['widgetMultimapConfig'] = { environment, staticConfigUrl: null };
  fetch(`/assets/module-federation-manifests/module-federation-${environment}.manifest.json`)
    .then((res) => res.json())
    .then(definitions => setRemoteDefinitions(definitions))
    .then(() => import('./bootstrap').catch(err => console.error(err)));


}